<template>
  <div class="chat-panel">
    <div style="position: relative;" class="container">
      
      <Divider dashed />
      <div class="chat-container">
        
        <!-- 左边侧边栏 -->
        <div class="chat-box-list">
            <div style="padding: 5px; display: flex; align-items: center;border-bottom: 1px solid #dcdee2;" class="chat-search">
              <div @click="isStoreShow = !isStoreShow" style="padding: 5px;cursor: pointer;" class="collapse-btn">    
                <Icon size="24" type="ios-options" />
              </div>
              <div @click="searchModal = true" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="ios-search" />
              </div>
              <div @click="knowledgeShow" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="md-book" />
              </div>
              <div @click="saleerShow" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="md-contacts" />
              </div>
              <div @click="sessionRefresh" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="session-refresh">
                <Icon size="24" type="md-refresh" />
              </div>
            </div>

            <div style="display: flex;" class="chat-box-side">            
              <Store v-if="isStoreShow" style="width: 20rem;background: #fff;" @updatesession="updatesession" ref="shopeeStoreElem"></Store>
              <Session style="width: 32rem" ref="sessionElem" @showChat="showChat" :sessionList="sessionList"></Session>
            </div>

        </div>
        <div v-if="currentStore.im_expiresin_text == '已过期'" class="store-expire-layer">
          <div style="display: flex;flex-direction: column;">          
            <div style="font-size: 18px;">该店铺授权已过期, 请前往授权</div>
            <div style="width: 80%;text-align: center;">            
              <Button @click="authorize" type="error">授权</Button>
            </div>
          </div>
        </div>
        <!-- 中间 -->
        <div class="chat-box">
          
          <UserChat ref="chatElem" :chat="currentSession" @emitPreviewImg="previewImgmsg" @previewshow="previewshow" @showChat="showChat"></UserChat>
        </div>

        <!-- 右边侧边栏 -->
        <div class="chat-side">
          <BuyerInfo ref="buyerInfoElem"></BuyerInfo>
          <SidePanel ref="sidePanelElem" :chat="currentSession"></SidePanel>
        </div>

      </div>

      <Preview @previewhide="previewhide" v-show="ispreview" :img="previewImg"></Preview>
      <PreImgmsg @preImgmsgHide="preImgmsgHide" v-show="preImgmsgData" :img="preImgmsgData"></PreImgmsg>
    </div>
    <Modal
        v-model="searchModal"
        title="查询中心"
        :footer-hide="true"
        >
        <SearchCenter></SearchCenter>
    </Modal>
    <!-- 知识 -->
    <Modal 
        v-model="knowledgeModal"
        title="知识"
        :footer-hide="true"
        width="80%"
        >
        <Knowledge ref="knowledgeElem"></Knowledge>
    </Modal>
    <Modal 
        v-model="saleServiceModal"
        title="售后服务"
        :footer-hide="true"
        width="80%"
        >
        <saleService ref="saleServiceElem"></saleService>
    </Modal>
  </div>
</template>
<script>
import SidePanel from "../../components/shopee/sidePanel.vue";
import BuyerInfo from "../../components/shopee/buyerInfo.vue";
import Session from "../../components/shopee/session.vue";
import Preview from "../../components/shopee/preview.vue";
import PreImgmsg from "../../components/shopee/preImgmsg.vue";
import Store from "../../components/shopee/store.vue";
import UserChat from "../../components/shopee/chat.vue";
import SearchCenter from "../../components/shopee/searchCenter.vue";
import RequestUtils from "@/utils/RequestUtils";
import Knowledge from "@/views/knowledge/knowledge_page.vue";
import saleService from "@/views/saleser/saleService.vue";
import EventBus from "@/utils/eventBus";

import {
  ChatListUtils,
  imageLoad,
  MessageTargetType,
} from "../../../../utils/ChatUtils";
import conf from "../../conf";

export default {
  components: {
    Store,
    UserChat,
    Preview,
    PreImgmsg,
    Session,
    BuyerInfo,
    SidePanel,
    SearchCenter,
    Knowledge,
    saleService
  },
  data() {
    return {
      isMounted: false,
      previewImg: '',
      ispreview: false,
      sessionList: [],
      showMessageBox: false,
      preImgmsgData: false,
      searchModal: false,
      knowledgeModal: false,
      saleServiceModal: false,
      isStoreShow: true
    };
  },
  computed: {
    sessionScroll() {
      if (this.isMounted) {      
        return window.innerHeight - this.$refs.shopeeStoreElem.$el.offsetHeight - 20;
      }
      return 500;
    },
    currentStore: {
      get: function () {
        return this.$store.state.shopee.currentStore;
      }
    },
    currentSession: {
      get: function() {
        return this.$store.state.shopee.currentSession;
      },
      set: function(currentSession) {
        this.$store.commit(
          "shopee/setCurrentSession",
          JSON.parse(JSON.stringify(currentSession))
        );
      }
    },
    sessionData: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        if (this.$store.state.shopee.sessionData[shop_id]) {        
          return this.$store.state.shopee.sessionData[shop_id];
        }
        return [];
      },
    }
  },
  methods: {
    // 店铺授权
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl('shopee'), param)
      .then(data => {      
        data.url = 'http://127.0.0.1/ecerp/public/stores/store/shopee_notify'
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    initData() {
      let self = this;
      let param = new FormData();
      param.set("connector", 'shopee');
      console.log('shopeestore');
      RequestUtils.request(conf.getStoresUrl(), param)
      .then(function (data) {
        if (data.length > 0) {        
          self.$store.commit("shopee/setStoreList", data);
          RequestUtils.webSocketSend('sessionList', {
            'platform': 'shopee'
          });
          // self.$refs.shopeeStoreElem.setCurrentStore(data[0]); 
          // self.$refs.shopeeStoreElem.selectstore(data[0], function () {
          //   self.updatesession();
          // });             
          // for (let i=1; i<data.length; i++) {
          //   self.$refs.shopeeStoreElem.selectstore(data[i]);
          // }
        }

      })
    },
    initSession(store) {
      let self = this;
      let param = new FormData();
      param.set("store_id", store.id);
      param.set("connector", 'shopee');

      self.$store.commit("shopee/setCurrentStore", store);
      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        data.store_id = store.id;
        data.shop_id = store.shop_id;
        let conversations = [];
        for (let i=0; i<data.conversations.length; i++) {
          if (data.conversations[i].last_message_time) {
            conversations.push(data.conversations[i]);
          }
        }
        data.conversations = conversations;
        self.$store.commit("shopee/setSessionData", data);
      })
    },
    updatesession () {
      let shop_id = this.$store.state.shopee.currentStore.shop_id;
      this.sessionList = this.$store.state.shopee.sessionData[shop_id].conversations;
    },
    showChat: function(session) {
      let self = this;
      if (this.currentStore.id != session.store_id) {
        for (var i=0; i<this.$store.state.shopee.storeList.length; i++) {
          if (this.$store.state.shopee.storeList[i].id == session.store_id) {
            this.$store.commit("shopee/setCurrentStore", this.$store.state.shopee.storeList[i]);
            break;
          }
        }
      }
      self.$store.commit("shopee/setCurrentSessionData", session);
      this.$refs.chatElem.getHistoryMessage();
      this.$refs.sidePanelElem.getOrder();
      this.$refs.buyerInfoElem.getBuyerInfo();
    },
    sessionOpen: function (session) {
      this.showChat(session);
      this.searchModal = false;
    },
    previewshow: function (data) {
      this.previewImg = data;
      this.ispreview = true;
    },
    previewhide: function () {
      this.ispreview = false;
    },
    previewImgmsg (item) {
      this.preImgmsgData = item;
    },
    preImgmsgHide () {
      this.preImgmsgData = false;
    },
    showSearchChat: function(chat) {
      let self = this;
      self.$store.commit("shopee/resetUnRead");
      self.currentChat = chat;
      // 每次滚动到最底部
      self.$nextTick(() => {
        imageLoad("message-box");
      });
      ChatListUtils.resetChatList(
        self,
        chat,
        conf.getHostUrl(),
        MessageTargetType.FRIEND
      );
    },
    knowledgeShow() {
      this.knowledgeModal = true;
      this.$refs.knowledgeElem.getKnowCate();
    },
    saleerShow() {
      this.saleServiceModal = true;
      this.$refs.saleServiceElem.refresh();
    },
    // 刷新session列表
    sessionRefresh() {
      RequestUtils.webSocketSend('sessionList', {
        'platform': 'shopee'
      });
      this.$Message.loading({
          content: '刷新中...',
          duration: 5
      });
    }
  },
  activated: function() {
    let self = this;
    // 每次滚动到最底部
    self.$nextTick(() => {
      imageLoad("message-box");
    });
  },
  mounted: function() {
    let self = this;
    this.isMounted = true;
    this.initData();
    EventBus.$on('shopeeOpenSession', args => {
      this.saleServiceModal = false;
      this.sessionOpen(args);
    })
    window.addEventListener('message', function(e) {
        var data = e.data;
        if (data.platform == 'shopee') {
          if (data.event == 'refresh') {                
            if (data.store) {
              self.$store.commit("shopee/setStoreAttr", data.store);
              self.$store.commit("shopee/setCurrentStore", data.store);
            }
          } else if (data.event == 'error') {
              self.$Message.error(data.message);
          } else if (data.event == 'success') {
              self.$Message.success(data.message);
          }
        }
    }) 
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.container {
  width: 100%;
}
.chat-container {
  display: flex;
  width: 100%;
  height: 100%;
}
.ivu-divider-horizontal {
  margin: 0px;
}
.chat-panel {
  width: 100%;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding-right: 1rem;

  .chat-box {
    flex: 1;
    background-color: $color-box-bg;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .chat-box-list {
    height: 100%;
    display: flex;
    flex-direction: column;

    .search-box {
      margin: 1.5rem;
      width: 19rem;
    }
  }

  .chat-side {
    height: 100%;
    width: 22%;
    display: flex;
    flex-direction: column;
  }
}

.portal-bg {
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 10%;
  flex-direction: column;
  flex-grow: 1;

  .portal-text {
    color: #4f566a;
    font-family: Roboto;
    text-align: center;
    font-size: 120%;
    min-width: 500px;

    h3 {
      line-height: 30px;
      font-size: 150%;
      font-weight: 700;
    }
    p {
      font-size: inherit;
      line-height: 22px;
      font-weight: 400;
    }
  }
  .portal-image {
    margin-top: 32px;
    padding: 24px 32px;
    background-color: #fff;
    border-radius: 12px;

    img {
      width: 600px;
    }
  }
}
</style>
